"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderWorkspacePickerButton = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
exports.HeaderWorkspacePickerButton = function (_a) {
    var _b;
    var title = _a.title, onClick = _a.onClick, isOpen = _a.isOpen;
    var classNames = classnames_1.default((_b = {
            "gd-header-project": true
        },
        _b["s-" + util_1.stringUtils.simplifyText(title)] = true,
        _b["is-expanded"] = isOpen,
        _b["is-collapsed"] = !isOpen,
        _b));
    return (react_1.default.createElement("div", { className: classNames, onClick: onClick }, title));
};
//# sourceMappingURL=HeaderWorkspacePickerButton.js.map